import { KYMW2500Model } from '../kymw2500.model';
import { OutputPagenationListModel } from '../vo/output-pagenation-list.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * ページネーション情報出力コマンド
 * サーバーにページネーション情報出力をリクエストし、ファイルを取得する。
 *
 * @export OutputPagenationListService
 * @class OutputPagenationListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class OutputPagenationListService extends PlessJsonResponderSub<any> {
  private model: KYMW2500Model = null;
  private vo: OutputPagenationListModel = null;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof OutputPagenationListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OutputDiv: this.vo.OutputDiv,
        OrderCode: this.vo.OrderCode,
        MediumType: this.vo.MediumType
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW2500Model} model モデルクラス
   * @param {OutputPagenationListModel} vo 出力用ページネーションリストVO
   * @param {Function} successFunc 成功時後続処理
   * @memberof OutputPagenationListService
   */
  execute(model: KYMW2500Model, vo: OutputPagenationListModel, successFunc: Function) {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('outputPagenationList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof OutputPagenationListService
   */
  success(data: any) {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
